/**
 * Listing Observability Event Names
 *
 * These constants define the event names tracked for listing view observability.
 * Used with NewRelic Browser APM for monitoring listing page load failures
 * and tracking data source resolution during the go-search migration.
 */

/**
 * Event tracked when listing fails to load
 */
export const LISTING_VIEW_FAILURE = 'listing_view_failure' as const;

/**
 * Event tracked when the listing data source is resolved (go-search vs client-app fallback).
 * Used to monitor the go-search migration progress.
 */
export const LISTING_SOURCE_RESOLVED = 'listing_source_resolved' as const;
